// Инициативы инженеров — реестр, заявки, свод по людям, дыры оформления. ТОЛЬКО ЧТЕНИЕ.
//
// ЧТО ЭТОТ ЭКРАН ОТВЕЧАЕТ. Инициатива — это не запись в базе портала, а ПЯТЬ ПОЛЕЙ НА
// СДЕЛКЕ Bitrix: дата, сумма вознаграждения инженеру, инженеры-инициаторы, сумма
// ремонтнику, ремонтники. Вознаграждение — 10 % чистой прибыли, между соинициаторами
// делится поровну (правило портала, initiatives.js:173). Экран отвечает на три вопроса:
// какие инициативы есть, кому и сколько причитается, и — главное — ГДЕ ВОЗНАГРАЖДЕНИЕ
// СГОРИТ, потому что поле заполнено неправильно.
//
// ПОЧЕМУ ЭТО НЕ КОПИЯ ПОРТАЛЬНОГО ЭКРАНА, А ШИРЕ ЕГО:
//   • портал берёт только сделки с датой инициативы позже 2026-01-01, в ядре лежат все;
//   • «дыр оформления» инженер на портале не видит вовсе, а админ видит их лишь по своей
//     усечённой копии. Здесь они по всем сделкам, и это единственное место в компании,
//     где видно «эти шесть сумм записаны текстом, значит бонус не начислится»;
//   • заявки инженеров и оформленные инициативы стоят рядом — на портале это два экрана
//     у двух разных ролей.
//
// ЧЕГО ЗДЕСЬ НЕТ И НЕ БУДЕТ. Подать заявку, вписать оценку, назначить вознаграждение —
// это записи в портал 73, в брифинг и в Bitrix соответственно. Раздел только читает;
// ссылки ведут туда, где правят.
//
// ЧЕГО ЭКРАН ПОКАЗАТЬ НЕ МОЖЕТ — блок «Чего этот раздел не знает» внизу собран из
// оговорок ядра, а не написан здесь руками, и потому не может отстать от данных.
import { useMemo, useState } from 'react'

import {
  useДыры, useЗаявкиИнициатив, useP73IRefs, useРеестрИнициатив, useСводПоЛюдям,
  useСходимостьИнициатив,
} from '../api/p73i'
import type {
  ЗаявкаСтрока, ИнициативаСтрока, ПроверкаСтрока, СправочникиP73I, Сходимость,
  ЧеловекСтрока,
} from '../api/p73i'
import { FilterBar } from '../components/FilterBar'
import { QueryState } from '../components/QueryState'
import { fmtDate, pluralN } from '../lib/format'
import {
  ИМЯ_СУЩНОСТИ, ПОРТАЛ_73_ИНИЦИАТИВЫ, РАЗМЕР_СТРАНИЦЫ, ВИДЫ_ДЫР,
  всеИнициаторы, заявки as заявокСловами, имяИнициатора, инициативы as инициативСловами,
  классДиагноза, классСтадии, классСтатуса, люди as людейСловами, месяцСловами,
  поСправочнику, рубли, свежесть, сделки as сделокСловами, ссылкаНаСделку,
  стадияБезИмени, ширеПортала, число,
} from '../lib/p73i'

type Вкладка = 'list' | 'people' | 'claims' | 'holes' | 'checks'

export default function Initiatives() {
  const [вкладка, setВкладка] = useState<Вкладка>('list')
  const refs = useP73IRefs()
  const свод = useСходимостьИнициатив()

  const счёт = refs.data?.counts
  const св = свежесть(refs.data?.freshness)

  return (
    <>
      <div className="page-head">
        <h1>Инициативы инженеров</h1>
        <span className="spacer" />
        <span className="hint">
          {св
            ? `обновлено ${св.age_min < 1 ? 'только что' : `${Math.round(св.age_min)} мин назад`}`
              + ` (позже всех — ${ИМЯ_СУЩНОСТИ[св.entity] ?? св.entity})`
            : 'свежесть неизвестна'}
        </span>
      </div>

      <Неизменяемо />

      <QueryState isLoading={refs.isLoading} error={refs.error}>
        {refs.data && <Плитки refs={refs.data} />}
        {refs.data && <ШирокийРеестр refs={refs.data} />}

        {/* Переключатель вкладок — обычный flex, а НЕ .filters: на телефоне правило
            «.filters > * { width: 100% }» ставит кнопки в столбец, и пять вкладок
            занимают весь первый экран до единственного, ради чего его открыли. */}
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
          {([
            ['list', `Реестр${счёт ? ` · ${счёт.deals}` : ''}`],
            ['people', `По людям${счёт ? ` · ${счёт.people}` : ''}`],
            ['claims', `Заявки${счёт ? ` · ${счёт.claims_open} ждут` : ''}`],
            ['holes', `Дыры оформления${счёт ? ` · ${счёт.with_issues}` : ''}`],
            ['checks', `Сходимость${свод.data ? ` · ${свод.data.total}` : ''}`],
          ] as [Вкладка, string][]).map(([код, подпись]) => (
            <button key={код} onClick={() => setВкладка(код)}
                    aria-pressed={вкладка === код}
                    style={{ fontWeight: вкладка === код ? 600 : 400, flex: '0 1 auto' }}>
              {подпись}
            </button>
          ))}
        </div>

        {вкладка === 'list' && <Реестр refs={refs.data} />}
        {вкладка === 'people' && <ПоЛюдям />}
        {вкладка === 'claims' && <Заявки refs={refs.data} />}
        {вкладка === 'holes' && <Дыры refs={refs.data} />}
        {вкладка === 'checks' && <Сходимости запрос={свод} />}

        {refs.data && <ЧегоНет refs={refs.data} />}
      </QueryState>
    </>
  )
}

/** Раздел ничего не пишет — и это сказано до данных, а не в подвале мелким шрифтом. */
function Неизменяемо() {
  return (
    <div className="notice">
      <b>Отсюда нельзя ни подать заявку, ни поставить вознаграждение.</b> Заявку инженер
      подаёт в портале 73, оценку вписывает координатор в брифинге, а сумма и инициаторы —
      это поля сделки в Bitrix, где на полях висят бизнес-процессы. Раздел только читает
      то, что там уже записано.{' '}
      <a href={ПОРТАЛ_73_ИНИЦИАТИВЫ} target="_blank" rel="noreferrer">
        Открыть инициативы в портале 73 ↗
      </a>
    </div>
  )
}

/** Пометка ядра «в ответе деньги нескольких людей». Показываем, а не прячем. */
function Закрыто({ почему }: { почему?: string }) {
  if (!почему) return null
  return (
    <div className="notice" style={{ marginBottom: 12, fontSize: 12 }}>
      Выборка по всем людям: {почему}. Раздел открыт одной учётке — не показывайте экран
      через плечо.
    </div>
  )
}

// ═══════════════════════════ шапка: числа раздела ═══════════════════════════

function Плитки({ refs }: { refs: СправочникиP73I }) {
  const с = refs.counts
  return (
    <div className="tiles" style={{ marginBottom: 12 }}>
      <div className="tile">
        <div className="t-label">инициатив в реестре</div>
        <div className="t-sum">{число(с.deals)}</div>
        <div className="t-label">
          с датой {с.with_date}; {с.date_from ?? '—'} … {с.date_to ?? '—'}
        </div>
      </div>
      <div className="tile">
        <div className="t-label">вознаграждения всего</div>
        <div className="t-sum">{рубли(с.eng_sum_total)}</div>
        <div className="t-label">
          разобрано {с.with_eng_sum} из {pluralN(с.with_eng_sum_raw, 'суммы', 'сумм', 'сумм')}
        </div>
      </div>
      <div className="tile">
        <div className="t-label">зачтено</div>
        <div className="t-sum">{рубли(с.eng_sum_counted)}</div>
        <div className="t-label">
          {сделокСловами(с.counted_deals)} на стадиях «Ждём оплату» и «Успех»
        </div>
      </div>
      <div className="tile">
        <div className="t-label">инициаторов</div>
        <div className="t-sum">{число(с.people)}</div>
        <div className="t-label">инженеры и ремонтники вместе</div>
      </div>
      <div className={с.with_issues > 0 ? 'tile hot' : 'tile'}>
        <div className="t-label">оформлено с непорядком</div>
        <div className="t-sum">{число(с.with_issues)}</div>
        <div className="t-label">
          из них {pluralN(с.eng_sum_unparsed, 'сумма', 'суммы', 'сумм')} записаны текстом
        </div>
      </div>
      <div className={с.claims_open > 0 ? 'tile hot' : 'tile'}>
        <div className="t-label">заявки ждут</div>
        <div className="t-sum">{число(с.claims_open)}</div>
        <div className="t-label">
          всего {заявокСловами(с.claims)} от {людейСловами(с.claim_people)}
        </div>
      </div>
    </div>
  )
}

/**
 * Насколько реестр CRM шире портального. Считается по периодам из ответа ядра: портал
 * берёт только сделки с датой позже 2026-01-01, и всё, что старше, у него не показано
 * никому. Если такого нет — блока нет: пустое хвастовство хуже молчания.
 */
function ШирокийРеестр({ refs }: { refs: СправочникиP73I }) {
  const старше = ширеПортала(refs)
  if (!старше) return null
  return (
    <div className="card hint" style={{ marginBottom: 12 }}>
      <b>Здесь видно больше, чем в портале.</b> Портал 73 подтягивает только инициативы с
      датой позже 2026-01-01; {сделокСловами(старше)} старше этой границы в нём не
      показаны никому, а в ядре они есть — потому что реестр строится не из его копии, а
      из самих сделок Bitrix.
    </div>
  )
}

// ═══════════════════════════ вкладка «Реестр» ═══════════════════════════

function Реестр({ refs }: { refs: СправочникиP73I | undefined }) {
  const [месяц, setМесяц] = useState('')
  const [стадия, setСтадия] = useState('')
  const [зачтено, setЗачтено] = useState('')
  const [человек, setЧеловек] = useState('')
  const [q, setQ] = useState('')
  const [сортировка, setСортировка] = useState('date')
  const [start, setStart] = useState(0)

  const сСброса = <T,>(setter: (v: T) => void) => (v: T) => { setStart(0); setter(v) }

  const фильтры = useMemo(() => ({
    // Один из двух обязателен, и это дверь ядра, а не наша: либо назван человек, либо
    // явное «по всем». Забыть — значит получить 400 вместо реестра.
    ...(человек ? { engineer_bx: человек } : { all: true }),
    month: месяц || undefined,
    stage: стадия || undefined,
    counted: зачтено === 'yes' ? true : undefined,
    q: q.trim() || undefined,
    sort: сортировка,
    start,
    limit: РАЗМЕР_СТРАНИЦЫ,
  }), [человек, месяц, стадия, зачтено, q, сортировка, start])

  const запрос = useРеестрИнициатив(фильтры)
  const данные = запрос.data
  const итоги = данные?.totals

  return (
    <>
      <Закрыто почему={данные?.restricted_why} />

      <div className="card" style={{ marginBottom: 16 }}>
        <FilterBar id="p73i-list">
          <div className="f" style={{ flex: 2, minWidth: 220 }}>
            <label htmlFor="iq">Сделка (название или сумма как записана)</label>
            <input id="iq" value={q} onChange={(e) => сСброса(setQ)(e.target.value)}
                   placeholder="например: магнетрон" />
          </div>

          <div className="f" style={{ minWidth: 200 }}>
            <label htmlFor="iwho">Инициатор</label>
            <select id="iwho" value={человек}
                    onChange={(e) => сСброса(setЧеловек)(e.target.value)}
                    disabled={!refs}>
              <option value="">все (свод по компании)</option>
              {(refs?.people ?? []).map((p) => (
                <option key={p.bx_id} value={p.bx_id}>
                  {p.name || `#${p.bx_id}`}{p.active === false ? ' (уволен)' : ''}
                  {' · '}{p.initiatives}
                </option>
              ))}
            </select>
          </div>

          <div className="f">
            <label htmlFor="imonth">Месяц инициативы</label>
            <select id="imonth" value={месяц}
                    onChange={(e) => сСброса(setМесяц)(e.target.value)} disabled={!refs}>
              <option value="">любой</option>
              {(refs?.periods ?? []).map((п) => (
                <option key={п.period} value={п.period}>
                  {месяцСловами(п.period)} · {п.deals}
                </option>
              ))}
            </select>
          </div>

          <div className="f">
            <label htmlFor="istage">Стадия сделки</label>
            <select id="istage" value={стадия}
                    onChange={(e) => сСброса(setСтадия)(e.target.value)} disabled={!refs}>
              <option value="">любая</option>
              {(refs?.stages ?? []).map((с) => (
                <option key={с.stage_id} value={с.stage_id}>
                  {поСправочнику(с.stage_id, refs?.stage_names)} · {с.deals}
                </option>
              ))}
            </select>
          </div>

          <div className="f">
            <label htmlFor="icounted">Зачтено</label>
            <select id="icounted" value={зачтено}
                    onChange={(e) => сСброса(setЗачтено)(e.target.value)}>
              <option value="">все</option>
              <option value="yes">только зачтённые</option>
            </select>
          </div>

          <div className="f">
            <label htmlFor="isort">Сортировка</label>
            <select id="isort" value={сортировка}
                    onChange={(e) => сСброса(setСортировка)(e.target.value)}>
              <option value="date">по дате инициативы</option>
              <option value="sum">по сумме вознаграждения</option>
              <option value="deal">по номеру сделки</option>
            </select>
          </div>
        </FilterBar>

        {итоги && (
          <div className="hint" style={{ marginTop: 10 }}>
            В выборке {сделокСловами(итоги.deals)} на {рубли(итоги.eng_sum)} инженерам
            {итоги.rem_sum > 0 && <> и {рубли(итоги.rem_sum)} ремонтникам</>}; зачтено{' '}
            {рубли(итоги.eng_sum_counted)} по{' '}
            {pluralN(итоги.counted_deals, 'сделке', 'сделкам', 'сделкам')}.
            {итоги.eng_sum_unparsed > 0 && (
              <> В {pluralN(итоги.eng_sum_unparsed, 'сумме', 'суммах', 'суммах')} вместо
                числа записан текст — они в итог не вошли и лежат во вкладке «Дыры
                оформления».</>
            )}{' '}
            Итоги посчитаны по всей выборке, а не по видимой странице.
          </div>
        )}
      </div>

      <QueryState isLoading={запрос.isLoading} error={запрос.error}>
        <div className="card">
          {/* `cards` — на телефоне таблица разбирается на карточки (styles.css, §12).
              Подписи колонок продублированы в data-label: шапки там на экране нет. */}
          <div className="table-wrap cards">
            <table>
              <thead>
                <tr>
                  <th className="nowrap">Сделка</th>
                  <th>Название</th>
                  <th className="nowrap">Дата</th>
                  <th className="nowrap">Стадия</th>
                  <th>Инициаторы</th>
                  <th className="num">Вознаграждение</th>
                  <th className="num">Доля одного</th>
                  <th>Непорядок</th>
                </tr>
              </thead>
              <tbody>
                {(данные?.rows ?? []).map((р) => (
                  <СтрокаРеестра key={р.deal_bitrix_id} р={р} refs={refs} />
                ))}
                {данные && данные.rows.length === 0 && (
                  <tr>
                    <td colSpan={8} className="empty">
                      <div className="empty-title">Под эти условия инициатив нет</div>
                      <div className="muted">
                        Это ответ «не нашлось», а не «раздел пуст»: всего в реестре{' '}
                        {инициативСловами(refs?.counts.deals)}.
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {данные && данные.total > РАЗМЕР_СТРАНИЦЫ && (
            <div className="pager">
              <button disabled={start === 0 || запрос.isFetching}
                      onClick={() => setStart(Math.max(0, start - РАЗМЕР_СТРАНИЦЫ))}>
                ← назад
              </button>
              <span className="muted">
                {start + 1}–{Math.min(start + РАЗМЕР_СТРАНИЦЫ, данные.total)} из {данные.total}
              </span>
              <button disabled={данные.next === null || запрос.isFetching}
                      onClick={() => setStart(данные.next!)}>вперёд →</button>
            </div>
          )}
        </div>
      </QueryState>
    </>
  )
}

function СтрокаРеестра({ р, refs }: {
  р: ИнициативаСтрока
  refs: СправочникиP73I | undefined
}) {
  const ссылка = ссылкаНаСделку(р.deal_bitrix_id)
  return (
    <tr>
      <td className="mono nowrap" data-label="Сделка">
        {ссылка
          ? <a href={ссылка} target="_blank" rel="noreferrer">#{р.deal_bitrix_id}</a>
          : <span className="muted">—</span>}
      </td>
      <td data-label="Название"
          style={{ maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {р.title || <span className="muted">без названия</span>}
      </td>
      <td className="nowrap" data-label="Дата">
        {р.init_date
          ? fmtDate(р.init_date)
          : <span className="muted" title="дата инициативы не заполнена — портал такую
              сделку не увидит вовсе">не заполнена</span>}
      </td>
      <td className="nowrap" data-label="Стадия">
        <span className={классСтадии(р)}>
          {поСправочнику(р.stage_id, refs?.stage_names)}
        </span>
        {стадияБезИмени(р.stage_id, refs?.stage_names) && (
          <div className="hint">названия стадии в зеркале нет</div>
        )}
      </td>
      <td data-label="Инициаторы">
        {всеИнициаторы(р).length === 0
          ? <span className="muted">не указаны</span>
          : всеИнициаторы(р).map((и) => (
              <div key={и.id} className="nowrap">{имяИнициатора(и)}</div>
            ))}
      </td>
      {/* Прочерк здесь — «числа нет в источнике», и это не то же, что ноль. Когда в поле
          лежит текст, показываем сам текст: он и есть то, что мешает начислению. */}
      <td className="num" data-label="Вознаграждение">
        {р.eng_sum !== null && р.eng_sum !== undefined
          ? рубли(р.eng_sum)
          : р.eng_sum_raw
            ? <span className="muted" title="в поле суммы записан текст">{р.eng_sum_raw}</span>
            : <span className="muted">—</span>}
        {!!р.rem_sum && (
          <div className="hint">ремонт: {рубли(р.rem_sum)}</div>
        )}
      </td>
      <td className="num" data-label="Доля одного">
        {р.eng_share !== null && р.eng_share !== undefined
          ? рубли(р.eng_share)
          : <span className="muted">—</span>}
      </td>
      <td data-label="Непорядок">
        {(р.issues ?? []).length === 0
          ? <span className="muted">—</span>
          : (р.issues ?? []).map((в) => (
              <div key={в}>
                <span className={классДиагноза(в)}>
                  {поСправочнику(в, refs?.issue_names)}
                </span>
              </div>
            ))}
        {р.claims > 0 && (
          <div className="hint">
            заявок по сделке: {р.claims}
          </div>
        )}
      </td>
    </tr>
  )
}

// ═══════════════════════════ вкладка «По людям» ═══════════════════════════

function ПоЛюдям() {
  const [q, setQ] = useState('')
  const [сортировка, setСортировка] = useState('rub')
  const [start, setStart] = useState(0)
  const сСброса = <T,>(setter: (v: T) => void) => (v: T) => { setStart(0); setter(v) }

  const запрос = useСводПоЛюдям(useMemo(() => ({
    all: true, q: q.trim() || undefined, sort: сортировка, start, limit: РАЗМЕР_СТРАНИЦЫ,
  }), [q, сортировка, start]))
  const данные = запрос.data
  const итоги = данные?.totals

  return (
    <>
      <Закрыто почему={данные?.restricted_why} />

      <div className="card" style={{ marginBottom: 16 }}>
        <FilterBar id="p73i-people">
          <div className="f" style={{ flex: 2, minWidth: 220 }}>
            <label htmlFor="pq">Фамилия</label>
            <input id="pq" value={q} onChange={(e) => сСброса(setQ)(e.target.value)}
                   placeholder="например: Плешаков" />
          </div>
          <div className="f">
            <label htmlFor="psort">Сортировка</label>
            <select id="psort" value={сортировка}
                    onChange={(e) => сСброса(setСортировка)(e.target.value)}>
              <option value="rub">по сумме</option>
              <option value="count">по числу инициатив</option>
              <option value="name">по фамилии</option>
            </select>
          </div>
        </FilterBar>

        <div className="hint" style={{ marginTop: 10 }}>
          Сумма сделки делится между соинициаторами <b>поровну</b> — так считает портал,
          другого правила в источнике нет. Здесь у человека стоит его доля, а не вся сумма
          сделки.{' '}
          {итоги && (
            <>
              Всего {людейСловами(итоги.people)} на {рубли(итоги.total_rub)}, из них
              зачтено {рубли(итоги.counted_rub)}.
            </>
          )}
        </div>
      </div>

      <QueryState isLoading={запрос.isLoading} error={запрос.error}>
        <div className="card">
          <div className="table-wrap cards">
            <table>
              <thead>
                <tr>
                  <th>Человек</th>
                  <th className="num">Инициатив</th>
                  <th className="num">Причитается</th>
                  <th className="num">Зачтено</th>
                  <th className="num">Ещё не зачтено</th>
                  <th className="nowrap">Период</th>
                </tr>
              </thead>
              <tbody>
                {(данные?.rows ?? []).map((ч) => <СтрокаЧеловека key={ч.bx_id} ч={ч} />)}
                {данные && данные.rows.length === 0 && (
                  <tr>
                    <td colSpan={6} className="empty">
                      <div className="empty-title">Под этот запрос людей нет</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {данные && данные.total > РАЗМЕР_СТРАНИЦЫ && (
            <div className="pager">
              <button disabled={start === 0 || запрос.isFetching}
                      onClick={() => setStart(Math.max(0, start - РАЗМЕР_СТРАНИЦЫ))}>
                ← назад
              </button>
              <span className="muted">
                {start + 1}–{Math.min(start + РАЗМЕР_СТРАНИЦЫ, данные.total)} из {данные.total}
              </span>
              <button disabled={данные.next === null || запрос.isFetching}
                      onClick={() => setStart(данные.next!)}>вперёд →</button>
            </div>
          )}
        </div>
      </QueryState>
    </>
  )
}

function СтрокаЧеловека({ ч }: { ч: ЧеловекСтрока }) {
  return (
    <tr>
      <td data-label="Человек">
        {ч.name || <span className="mono">#{ч.bx_id}</span>}
        {ч.active === false && <span className="muted"> (уволен)</span>}
        {ч.p73_d1_id === null && (
          <div className="hint">учётки в портале 73 нет</div>
        )}
      </td>
      <td className="num" data-label="Инициатив">
        {ч.initiatives}
        {ч.as_repairman > 0 && (
          <div className="hint">
            как ремонтник: {ч.as_repairman}
          </div>
        )}
        {ч.unparsed > 0 && (
          <div className="hint">
            без суммы числом: {ч.unparsed}
          </div>
        )}
      </td>
      <td className="num" data-label="Причитается">{рубли(ч.total_rub)}</td>
      <td className="num" data-label="Зачтено">{рубли(ч.counted_rub)}</td>
      {/* Ноль здесь — посчитанный ноль: «всё зачтено», а не «не знаем». Прочерк был бы
          неправдой ровно про того, кто ждёт денег. */}
      <td className="num" data-label="Ещё не зачтено">
        {Number(ч.pending_rub) > 0
          ? рубли(ч.pending_rub)
          : <span className="muted" title="всё, что причиталось, уже на оплатных стадиях">
              0 ₽
            </span>}
      </td>
      <td className="nowrap muted" data-label="Период">
        {ч.first_date ? fmtDate(ч.first_date) : '—'} … {ч.last_date ? fmtDate(ч.last_date) : '—'}
      </td>
    </tr>
  )
}

// ═══════════════════════════ вкладка «Заявки» ═══════════════════════════

function Заявки({ refs }: { refs: СправочникиP73I | undefined }) {
  const [статус, setСтатус] = useState('')
  const [q, setQ] = useState('')
  const [start, setStart] = useState(0)
  const сСброса = <T,>(setter: (v: T) => void) => (v: T) => { setStart(0); setter(v) }

  const запрос = useЗаявкиИнициатив(useMemo(() => ({
    status: статус || undefined, q: q.trim() || undefined,
    start, limit: РАЗМЕР_СТРАНИЦЫ,
  }), [статус, q, start]))
  const данные = запрос.data
  const итоги = данные?.totals

  return (
    <>
      <div className="card" style={{ marginBottom: 16 }}>
        <FilterBar id="p73i-claims">
          <div className="f" style={{ flex: 2, minWidth: 220 }}>
            <label htmlFor="cq">Текст заявки или сделка</label>
            <input id="cq" value={q} onChange={(e) => сСброса(setQ)(e.target.value)}
                   placeholder="например: эхолот" />
          </div>
          <div className="f">
            <label htmlFor="cst">Состояние</label>
            <select id="cst" value={статус}
                    onChange={(e) => сСброса(setСтатус)(e.target.value)}>
              <option value="">любое</option>
              {(refs?.claim_statuses ?? []).map((с) => (
                <option key={с.status} value={с.status}>
                  {поСправочнику(с.status, refs?.status_names)} · {с.claims}
                </option>
              ))}
            </select>
          </div>
        </FilterBar>

        <div className="hint" style={{ marginTop: 10 }}>
          <b>Оценка в заявке — это стоимость работы для сметы, а не вознаграждение
          инженеру.</b> Бонус появится только тогда, когда координатор впишет сумму в поле
          сделки; до тех пор заявка — предложение, и денег за ней нет.
          {итоги && (
            <> Сейчас {заявокСловами(итоги.claims)} от {людейСловами(итоги.people)}: ждут
              оценки {итоги.need_estimate}, ждут обработки {итоги.new}, обработано{' '}
              {итоги.processed}; оценок на {рубли(итоги.estimate_rub)}.</>
          )}
        </div>
      </div>

      <QueryState isLoading={запрос.isLoading} error={запрос.error}>
        <div className="card">
          <div className="table-wrap cards">
            <table>
              <thead>
                <tr>
                  <th className="nowrap">Подана</th>
                  <th className="nowrap">Инженер</th>
                  <th>Что предлагает</th>
                  <th className="nowrap">Сделка</th>
                  <th className="num">Оценка работы</th>
                  <th className="nowrap">Состояние</th>
                  <th className="nowrap">Оформлена</th>
                </tr>
              </thead>
              <tbody>
                {(данные?.rows ?? []).map((з) => (
                  <СтрокаЗаявки key={з.d1_id} з={з} refs={refs} />
                ))}
                {данные && данные.rows.length === 0 && (
                  <tr>
                    <td colSpan={7} className="empty">
                      <div className="empty-title">Под эти условия заявок нет</div>
                      <div className="muted">
                        Всего в зеркале {заявокСловами(refs?.counts.claims)}.
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {данные && данные.total > РАЗМЕР_СТРАНИЦЫ && (
            <div className="pager">
              <button disabled={start === 0 || запрос.isFetching}
                      onClick={() => setStart(Math.max(0, start - РАЗМЕР_СТРАНИЦЫ))}>
                ← назад
              </button>
              <span className="muted">
                {start + 1}–{Math.min(start + РАЗМЕР_СТРАНИЦЫ, данные.total)} из {данные.total}
              </span>
              <button disabled={данные.next === null || запрос.isFetching}
                      onClick={() => setStart(данные.next!)}>вперёд →</button>
            </div>
          )}
        </div>
      </QueryState>
    </>
  )
}

function СтрокаЗаявки({ з, refs }: {
  з: ЗаявкаСтрока
  refs: СправочникиP73I | undefined
}) {
  const ссылка = ссылкаНаСделку(з.deal_bitrix_id)
  return (
    <tr>
      <td className="nowrap muted" data-label="Подана">{fmtDate(з.created_at, true)}</td>
      <td className="nowrap" data-label="Инженер">
        {з.engineer || <span className="muted">учётка #{з.user_d1_id ?? '?'}</span>}
      </td>
      <td data-label="Что предлагает" style={{ maxWidth: 420 }}>
        {з.claim_text || <span className="muted">текста нет</span>}
      </td>
      <td className="mono nowrap" data-label="Сделка">
        {ссылка
          ? <a href={ссылка} target="_blank" rel="noreferrer">#{з.deal_bitrix_id}</a>
          : <span className="muted">без привязки</span>}
        {/* Номер есть, а сделки в зеркале нет — это расхождение, и молчать о нём нельзя. */}
        {з.deal_bitrix_id !== null && з.deal_now === null && (
          <div className="hint">такой сделки в ядре нет</div>
        )}
      </td>
      <td className="num" data-label="Оценка работы">
        {з.estimate_rub !== null && з.estimate_rub !== undefined
          ? рубли(з.estimate_rub)
          : <span className="muted">не оценена</span>}
        {з.estimated_by && (
          <div className="hint">оценил {з.estimated_by}</div>
        )}
      </td>
      <td className="nowrap" data-label="Состояние">
        <span className={классСтатуса(з.status)}>
          {поСправочнику(з.status, refs?.status_names)}
        </span>
      </td>
      {/* Совпадение по номеру сделки, а не связь: связи в источнике нет вовсе. */}
      <td className="nowrap" data-label="Оформлена">
        {з.in_registry
          ? <span className="badge won">есть в реестре</span>
          : з.deal_bitrix_id
            ? <span className="muted" title="полей инициативы на этой сделке не завели —
                вознаграждения по ней не будет">нет</span>
            : <span className="muted">—</span>}
      </td>
    </tr>
  )
}

// ═══════════════════════════ вкладка «Дыры оформления» ═══════════════════════════

function Дыры({ refs }: { refs: СправочникиP73I | undefined }) {
  const [вид, setВид] = useState('')
  const [start, setStart] = useState(0)

  const запрос = useДыры(useMemo(() => ({
    all: true, kind: вид || undefined, start, limit: РАЗМЕР_СТРАНИЦЫ,
  }), [вид, start]))
  const данные = запрос.data
  const итоги = данные?.totals

  return (
    <>
      <Закрыто почему={данные?.restricted_why} />

      <div className="notice" style={{ marginBottom: 12 }}>
        <b>Здесь вознаграждение сгорит молча.</b> Портал начисляет бонус только по тем
        сделкам, где заполнены и дата, и сумма числом, и инициатор. Ни инженер, ни
        координатор этот список у себя не видят: на портале похожая проверка есть только у
        админа и только по его усечённой копии реестра. Исправляется всё это в Bitrix —
        отсюда нельзя.
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        {/* Разбивка по видам считается ядром БЕЗ фильтра по виду: иначе при выборе
            «сумма текстом» стояло бы «6 из 6», и остальные 22 сделки исчезли бы. */}
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <button onClick={() => { setВид(''); setStart(0) }} aria-pressed={вид === ''}
                  style={{ fontWeight: вид === '' ? 600 : 400 }}>
            все · {итоги?.deals ?? '—'}
          </button>
          {ВИДЫ_ДЫР.map((в) => (
            <button key={в} onClick={() => { setВид(в); setStart(0) }}
                    aria-pressed={вид === в}
                    style={{ fontWeight: вид === в ? 600 : 400 }}>
              {поСправочнику(в, refs?.issue_names)} · {итоги?.[в] ?? '—'}
            </button>
          ))}
        </div>
        <div className="hint" style={{ marginTop: 10 }}>
          Одна сделка может попасть сразу в несколько строк — например, и без даты, и без
          суммы. Поэтому числа рядом с кнопками не складываются в общее.
          {итоги && итоги.eng_sum > 0 && (
            <> По этим сделкам уже проставлено {рубли(итоги.eng_sum)} — они не начислятся,
              пока непорядок не устранён.</>
          )}
        </div>
      </div>

      <QueryState isLoading={запрос.isLoading} error={запрос.error}>
        <div className="card">
          <div className="table-wrap cards">
            <table>
              <thead>
                <tr>
                  <th className="nowrap">Сделка</th>
                  <th>Название</th>
                  <th className="nowrap">Дата</th>
                  <th>Инициаторы</th>
                  <th className="num">Что в поле суммы</th>
                  <th>Что не так</th>
                </tr>
              </thead>
              <tbody>
                {(данные?.rows ?? []).map((р) => (
                  <СтрокаДыры key={р.deal_bitrix_id} р={р} refs={refs} />
                ))}
                {данные && данные.rows.length === 0 && (
                  <tr>
                    <td colSpan={6} className="empty">
                      <div className="empty-title">
                        {вид ? 'Дыр этого вида нет' : 'Все инициативы оформлены правильно'}
                      </div>
                      <div className="muted">
                        Это посчитанный ноль, а не «не смотрели»: проверены все{' '}
                        {инициативСловами(refs?.counts.deals)} реестра.
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {данные && данные.total > РАЗМЕР_СТРАНИЦЫ && (
            <div className="pager">
              <button disabled={start === 0 || запрос.isFetching}
                      onClick={() => setStart(Math.max(0, start - РАЗМЕР_СТРАНИЦЫ))}>
                ← назад
              </button>
              <span className="muted">
                {start + 1}–{Math.min(start + РАЗМЕР_СТРАНИЦЫ, данные.total)} из {данные.total}
              </span>
              <button disabled={данные.next === null || запрос.isFetching}
                      onClick={() => setStart(данные.next!)}>вперёд →</button>
            </div>
          )}
        </div>
      </QueryState>
    </>
  )
}

function СтрокаДыры({ р, refs }: {
  р: ИнициативаСтрока
  refs: СправочникиP73I | undefined
}) {
  const ссылка = ссылкаНаСделку(р.deal_bitrix_id)
  return (
    <tr>
      <td className="mono nowrap" data-label="Сделка">
        {ссылка
          ? <a href={ссылка} target="_blank" rel="noreferrer">#{р.deal_bitrix_id}</a>
          : <span className="muted">—</span>}
      </td>
      <td data-label="Название"
          style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {р.title || <span className="muted">без названия</span>}
      </td>
      <td className="nowrap" data-label="Дата">
        {р.init_date ? fmtDate(р.init_date) : <span className="muted">не заполнена</span>}
      </td>
      <td data-label="Инициаторы">
        {всеИнициаторы(р).length === 0
          ? <span className="muted">не указаны</span>
          : всеИнициаторы(р).map((и) => (
              <div key={и.id} className="nowrap">{имяИнициатора(и)}</div>
            ))}
      </td>
      {/* Показываем СОДЕРЖИМОЕ поля как есть — оно и есть причина. «—» здесь значит
          «поле пустое», и это другой диагноз, чем «в поле текст». */}
      <td className="num" data-label="Что в поле суммы">
        {р.eng_sum_raw
          ? <span className="mono">{р.eng_sum_raw}</span>
          : <span className="muted">пусто</span>}
      </td>
      <td data-label="Что не так">
        {(р.issues ?? []).map((в) => (
          <div key={в}>
            <span className={классДиагноза(в)}>{поСправочнику(в, refs?.issue_names)}</span>
          </div>
        ))}
      </td>
    </tr>
  )
}

// ═══════════════════════════ вкладка «Сходимость» ═══════════════════════════

function Сходимости({ запрос }: {
  запрос: { data?: Сходимость; isLoading: boolean; error: unknown }
}) {
  const строки = запрос.data?.rows ?? []
  const снаходками = строки.filter((п) => п.rows > 0).length
  return (
    <QueryState isLoading={запрос.isLoading} error={запрос.error}>
      <div className="card">
        <div className="hint" style={{ marginBottom: 10 }}>
          {снаходками === 0
            ? 'Ни одна проверка ничего не нашла. Строки с нулём остаются на месте — '
              + 'исчезнувшая проверка читалась бы как «такой беды не бывает».'
            : `Нашли что сказать: ${pluralN(снаходками, 'проверка', 'проверки', 'проверок')} `
              + `из ${строки.length}. Ноль в строке — это проверенный ноль, а не «не смотрели».`}
        </div>
        <div className="table-wrap cards">
          <table>
            <thead>
              <tr>
                <th>Проверка</th>
                <th className="num">Строк</th>
                <th>Почему это важно</th>
              </tr>
            </thead>
            <tbody>
              {строки.map((п) => <СтрокаПроверки key={п.check} п={п} />)}
              {запрос.data && строки.length === 0 && (
                <tr>
                  <td colSpan={3} className="empty">
                    <div className="empty-title">Ядро не вернуло ни одной проверки</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </QueryState>
  )
}

function СтрокаПроверки({ п }: { п: ПроверкаСтрока }) {
  return (
    <tr>
      <td data-label="Проверка">{п.check}</td>
      <td className="num" data-label="Строк">
        {п.rows > 0
          ? <b>{число(п.rows)}</b>
          : <span className="muted" title="проверено, расхождений нет">0</span>}
      </td>
      <td className="muted" data-label="Почему это важно">{п.why}</td>
    </tr>
  )
}

// ═══════════════════════ чего этот раздел не знает ═══════════════════════

/**
 * Оговорки печатаются СЛОВАМИ ЯДРА и с его же числами. Переписать их здесь значило бы
 * завести вторую редакцию правды: ядро считает числа на тот же запрос, а экран показал бы
 * вчерашние. Список пуст — блока нет.
 */
function ЧегоНет({ refs }: { refs: СправочникиP73I }) {
  if (!refs.caveats?.length) return null
  return (
    <div className="card" style={{ marginTop: 16 }}>
      <h3>Чего этот раздел не знает</h3>
      <ul className="muted" style={{ margin: '8px 0 0', paddingLeft: 20 }}>
        {refs.caveats.map((т, i) => <li key={i} style={{ marginBottom: 6 }}>{т}</li>)}
      </ul>
      <div className="hint" style={{ marginTop: 10 }}>Источник: {refs.source}</div>
    </div>
  )
}
